import React from 'react';
import styleFile from './style';
import { compose } from 'ramda';
import {RichText, Button, Image} from '@synergycms_core/components/generic';
import {FIDELTOUR_CODE, STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import { dispatchEvent } from '@synergycms_app/utils';
import FidelTourManagement from './FidelTour/Side/FidelTourManagement.jsx';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import {connect} from 'react-redux';
import { getSTPoints } from '../../../store/customer/loyaltyUtils';
import { hasAppliedLoyaltyDiscount } from '../../../store/avail/availUtils.js';



const LoyaltyLogin = ({ theme,  theme: { styles: { classes }}, loyaltyUser, loyaltyType, rateStarTravelerSelected, customerForm, webType, group, hidePromoWithoutLoyalty }) => {
  if (hidePromoWithoutLoyalty) return null;

  const alias = group === 'eurostarshotels' && webType === 'WI' ? 'cms-login' : 'cms-login-dispo';
  if (loyaltyType === FIDELTOUR_CODE) {
    return (<FidelTourManagement customerForm={customerForm}/>);
  } else if(!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE) {
    return (<div className={[theme.computedInnerStyle,  classes.starTravLogInSection].join(' ') }>
        <div className={classes.starTravLogInLogo}>
          <Image svg={'stDefaultLogoHz'} />          
        </div>
        {
          rateStarTravelerSelected ?
            <RichText innerStyle={[classes.starTravLogInTxt]} text={"_%Si eres <b>Star Traveler</b> inicia sesión para completar tu reserva. Si no te daremos de alta al finalizar el proceso%_"} translate={true} dangerouslySetInnerHTML={true}/> :
            <RichText innerStyle={[classes.starTravLogInTxt]} text={"_%Si eres <b>Star Traveler</b> inicia sesión para completar tu reserva.%_"} translate={true} dangerouslySetInnerHTML={true}/>
        }

        <Button innerStyle={['toggleMainButton','capitalize']} onClick={()=> dispatchEvent("toggleLogin", {alias:alias,open:true})} translate={true} richText={{translate:true,text:"_%iniciar sesión%_"}}/>
      </div>);
  } else if(loyaltyUser && loyaltyType === STAR_TRAVELER_CODE) {
    const loyaltyUserTier = loyaltyUser.getIn(['tier','current']);
    return (<div className={[theme.computedInnerStyle,  classes.starTravLogInSection].join(' ') }>
        <div className={classes.starTravLogInLogo}>
          <Image svg={loyaltyUserTier === 'silver' ? 'stSilverLogoHz' : loyaltyUserTier === 'gold' ? 'stGoldLogoHz' : 'stBlueLogoHz'} />          
        </div>
        <RichText ucFirst={true} innerStyle={[classes.starTravLogInTxt]} text={"_%<b>hola {nombre}</b> ya puedes finalizar tu reserva%_"} translate={true} dangerouslySetInnerHTML={true} withVars={{nombre: loyaltyUser.get('name')}}/>
      </div>);
  } else {
    return null;
  }
  
};

const mapStateToProps = (store) => {

  let accumulatePoints = getSTPoints(store);
  const reservation = store.getIn(['customer', 'reservation']);
  const hasPromotionCode = !!(reservation && reservation.getIn(['promotion', 'code'], false));

  // Con codigo promocional aplicado y sin descuento loyalty en la tarifa, no se ofrece el login de fidelizacion
  return {
    loyaltyType: store.getIn(['customer', 'loyalty', 'data', 'loyalty','code'], null),
    loyaltyUser : store.getIn(['customer', 'loyalty','user','user_id'], null) && store.getIn(['customer', 'loyalty','user'], null),
    rateStarTravelerSelected : accumulatePoints > 0,
    webType: store.getIn(['customer', 'web_type'], null),
    group: store.getIn(['group'], null),
    hidePromoWithoutLoyalty: hasPromotionCode && !hasAppliedLoyaltyDiscount(reservation),
  };
};

export default compose(connect(mapStateToProps), withThemeJSS({ styleFile, displayName : "LoyaltyLogin", link: true }), withContent('i18n'))(LoyaltyLogin);